import { changePassword } from "./asyncThunks";

export const changePasswordBuilder = (builder) => {
  builder.addCase(changePassword.pending, (state) => {
    state.loading = true;
    state.error = null;
    state.message = null;
  });
  builder.addCase(changePassword.fulfilled, (state, action) => {
    state.loading = false;
    state.error = null;
    state.message = action.payload.message;
  });
  builder.addCase(changePassword.rejected, (state, action) => {
    state.loading = false;
    state.error = action.error.message;
    state.message = null;
  });
};